import React from 'react';
import PCImport from 'cards/components/common/PlaceCardAssignStep/Import';

export const ImportModal = props => <PCImport.Import {...props} />;
export const WarningModal = props => <PCImport.Warning {...props} />;
